import type { Pattern } from "../types.js";

/**
 * REAL CONTENT — eneatipo 8. Portado de
 * `docs/canonical/Plantilla_maestra_nueve_eneatipos.docx`, Bloques A, B, D y E.
 *
 * En inglés, con el original español al lado de cada campo, igual que los
 * patrones 1, 6 y 9.
 *
 * Las marcas del canon se conservan: [PROPUESTA] es formulación del proyecto,
 * [LÍMITE] es un riesgo declarado, [FUENTE PROYECTO] viene de Vilaseca. Que
 * `shortHypothesis` sea [PROPUESTA] y no fuente externa importa: es la frase
 * que la persona lee como resultado.
 *
 * PARES: el Bloque E del 8 trata el 7 y el 9. El 1↔8 sale del lado del 1.
 */
export const PATTERN_8: Pattern = {
  id: "8",
  number: 8,
  // «el protector» — Vilaseca: «el desafiador»
  workingName: "The protector (working name)",
  // Patrón organizado alrededor de tomar el control para no ser herido/a o dominado/a por otros
  shortHypothesis:
    "A pattern organised around taking control so as not to be hurt or " +
    "dominated by anyone else.",
  // Confrontación directa, dificultad para mostrar vulnerabilidad, necesidad de controlar la situación
  whatItExplains:
    "Direct confrontation, difficulty showing vulnerability, and a need to " +
    "control the situation.",
  // El contenido concreto de qué considera cada persona una injusticia; el origen de un conflicto de autoridad puntual
  whatItDoesNotExplain:
    "What any given person counts as an injustice, or where one specific " +
    "clash with authority came from.",
  // [LÍMITE] Que la persona se defina como «la dura de siempre» y use la etiqueta para evitar mostrar vulnerabilidad nunca
  identityRisk:
    "Defining yourself as \u201cthe tough one\u201d and using the label to avoid ever " +
    "showing vulnerability.",
  confusablePatterns: ["1", "7", "9"],
  sourceRefs: [
    "Plantilla_maestra_nueve_eneatipos.docx, Eneatipo 8, Bloques A, B, D y E",
    "[LÍMITE] Vilaseca-céntrico: sin triangular contra una segunda fuente"
  ],
  contentVersion: "canon-nueve-1.0"
};
